import axios from "axios";
import { apiUrl } from "../../config";

export const getSalePrice = (quantity,product_code) => {
    const params = {
        quantity: quantity,
        product_code: product_code
    };
    return axios.get(`${apiUrl}/price/cal_sale_price`, { params });
};